export default __webpack_public_path__ + "static/media/bg-register.36f0900a.jpg";